// extracted by mini-css-extract-plugin
export var applicationInformationContractsRow = "FormPreview-module__applicationInformationContractsRow___fSc2o";
export var applicationInformationCopyColumn = "FormPreview-module__applicationInformationCopyColumn___o2DmN";
export var applicationInformationGameDetailsRow = "FormPreview-module__applicationInformationGameDetailsRow___Ko11k";
export var applicationInformationHeaderRow = "FormPreview-module__applicationInformationHeaderRow___O0ES2";
export var applicationInformationIconColumn = "FormPreview-module__applicationInformationIconColumn___iefTv";
export var backButton = "FormPreview-module__backButton___iJvs2";
export var previewContainer = "FormPreview-module__previewContainer___Pq8Ex";
export var table = "FormPreview-module__table___5o83x";
export var td = "FormPreview-module__td___T60s8";
export var tdFirst = "FormPreview-module__tdFirst___uw4pk";
export var tdheader = "FormPreview-module__tdheader___pKySE";
export var title = "FormPreview-module__title___w6SzL";
export var tr = "FormPreview-module__tr___nay81";
export var trArray = "FormPreview-module__trArray___c2WFD";
export var trArrayFirst = "FormPreview-module__trArrayFirst___7k8Cc";
export var trArrayLast = "FormPreview-module__trArrayLast___yo3lE";
export var xboxGreen = "#107C10";